import Utility from "./utility.js";
import { Common } from "../Components/Canvas";
import Draw from "./draw";

export default class Bucket {
  constructor(ctx, color) {
    this.ctx = ctx;
    this.fillStack = [];
    this.history_ctx = Common.history_ctx;

    // read the pixels in the canvas
    this.imageData = this.ctx.getImageData(
      0,
      0,
      this.ctx.canvas.width,
      this.ctx.canvas.height
    );
    // for history;
    this.historyImageData = this.history_ctx.getImageData(
      0,
      0,
      this.ctx.canvas.width,
      this.ctx.canvas.height
    );

    this.floodFill(
      Common.mouse_position.x,
      Common.mouse_position.y,
      Utility.hexToRgba(color)
    );
  }

  getPixel(x, y) {
    if (
      x < 0 ||
      y < 0 ||
      x >= this.imageData.width ||
      y >= this.imageData.height
    ) {
      return [-1, -1, -1, -1]; // impossible color
    } else {
      const offset = (Math.round(y) * this.imageData.width + Math.round(x)) * 4;

      return [
        this.imageData.data[offset + 0],
        this.imageData.data[offset + 1],
        this.imageData.data[offset + 2],
        this.imageData.data[offset + 3],
      ];
    }
  }

  setPixel(x, y, color) {
    const offset = (Math.round(y) * this.imageData.width + Math.round(x)) * 4;
    this.imageData.data[offset + 0] = color[0];
    this.imageData.data[offset + 1] = color[1];
    this.imageData.data[offset + 2] = color[2];
    this.imageData.data[offset + 3] = color[3];

    // for history;
    this.historyImageData.data[offset + 0] = color[0];
    this.historyImageData.data[offset + 1] = color[1];
    this.historyImageData.data[offset + 2] = color[2];
    this.historyImageData.data[offset + 3] = color[3];
  }

  colorsMatch(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3];
  }

  // runs only 1 time;
  floodFill(x, y, fillColor) {
    // get the color we're filling
    const targetColor = this.getPixel(x, y);

    // check we are actually filling a different color
    if (!this.colorsMatch(targetColor, fillColor)) {
      this.fillPixel(x, y, targetColor, fillColor);
      this.fillCol();
      // put the data back
    }
  }

  fillPixel(x, y, targetColor, fillColor) {
    const currentColor = this.getPixel(x, y);

    if (this.colorsMatch(currentColor, targetColor)) {
      this.setPixel(x, y, fillColor);
      this.fillStack.push([x + 1, y, targetColor, fillColor]);
      this.fillStack.push([x - 1, y, targetColor, fillColor]);
      this.fillStack.push([x, y + 1, targetColor, fillColor]);
      this.fillStack.push([x, y - 1, targetColor, fillColor]);
    }
  }

  fillCol() {
    if (this.fillStack.length) {
      let range = this.fillStack.length;

      for (let i = 0; i < range; i++) {
        this.fillPixel(
          this.fillStack[i][0],
          this.fillStack[i][1],
          this.fillStack[i][2],
          this.fillStack[i][3]
        );
      }

      this.fillStack.splice(0, range);

      this.fillCol();
    } else {
      this.ctx.putImageData(this.imageData, 0, 0);

      // for history;
      this.history_ctx.putImageData(this.historyImageData, 0, 0);
      Draw.history.addToHistoryTest();
      Draw.history.redrawHistory();

      this.fillStack = [];
    }
  }
}
